import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-politics',
  templateUrl: './politics.component.html',
  styleUrls: ['./politics.component.sass']
})
export class PoliticsComponent implements OnInit {
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public tabActive='Compras';
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  public selTab: number;
  constructor( private loadingScreenService: LoadingScreenService,public AngularFireAnalytics:AngularFireAnalytics, private router: Router,private route: ActivatedRoute,public global:GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Políticas");
    this.AngularFireAnalytics.logEvent("Políticas-Screenview");
   }

  ngOnInit() {
    this.selTab = 1;
    this.getId();
  }
  initializeData(){
  //  this.global.refreshDataTo(this.token);
  }
  statusChange(sw) {
    this.selTab = sw;
  }
  getId() {
    if (this.route.firstChild) {
      var id = this.route.firstChild.snapshot.params.id;
      this.loadingScreenService.stopLoading();
      if (id == '1') {
        this.selTab = 1;
      }
      else if (id == '2') {
        this.selTab = 2;
      }
      else if (id == '3') {
        this.selTab = 3;
      }
      else {
        this.selTab = 1;
        this.router.navigate(['politics']);
      }
    }
  } 
}